import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type DeleteOnboardingTaskInput = {
  partnerId: string;
  taskId: string;
};

// DELETE /api/partners/:id/onboarding/:taskId
export function useDeleteOnboardingTask() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, DeleteOnboardingTaskInput>({
    mutationFn: ({ partnerId, taskId }) =>
      apiFetch<{ ok: true }>(`/partners/${partnerId}/onboarding/${taskId}`, {
        method: "DELETE",
      }),
    onSuccess: (_data, { partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.onboarding(partnerId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.detail(partnerId) });
      // Sub-bucket 10 — admin overview aggregate (openTasks count).
      queryClient.invalidateQueries({ queryKey: queryKeys.admin.partners.overview(partnerId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete task");
    },
  });
}
